import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css"; // ★ お知らせ/Docs と共通のCSS

const ItemsRow = (props) => {
  //console.log(props);
  return (
    <div className="ann-row ann-row-body">
      <div className="ann-col ann-col-movie-cat">
        {props.subcategory_name || props.category_name}
      </div>
      <div className="ann-col ann-col-movie-title">{props.title}</div>

      <div className="ann-col ann-col-movie-file" title={props.filename}>
        <a href={props.movieUrl} target="_blank">
          {props.filename}
        </a>
      </div>

      <div className="ann-col ann-col-movie-sort">{props.sortno}</div>

      <div className="ann-col ann-col-actions">
        <Link
          to={"/movies/" + props.id}
          data-id={props.id}
          className="btn btn-ghost btn-sm"
          style={{ marginRight: "0.2rem" }}
        >
          編集
        </Link>

        <Link
          to={"/movies/delete/" + props.id}
          data-id={props.id}
          className="btn btn-danger btn-sm"
        >
          削除
        </Link>
      </div>
    </div>
  );
};

const api_url = "https://api.ope-note.jp/admin/movies.php";

const MoviesHome = () => {
  const [itemList, setItemList] = useState([]);
  const [page, setCurrentPage] = useState(1);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            page: page,
            mode: "list",
            token: token,
          }),
        });
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("404");
          }
          if (response.status === 401) {
            throw new Error("401");
          }
          throw new Error(response.status);
        }
        const data = await response.json();
        setItemList(data.data);
      } catch (err) {
        console.log(err);
        if (err.message === "404" || err.message === "401") {
          navigate("/login");
        }
        setItemList([]);
      }
    };
    fetchData();
  }, [page, token, navigate]);

  const tablelist = itemList.map((item) => (
    <ItemsRow
      key={item.id}
      title={item.title}
      id={item.id}
      thumbnail={item.thumbnail}
      subcategory_name={item.subcategory_title}
      category_name={item.category_title}
      sortno={item.sortno}
      filename={item.file}
      movieUrl={item.movie_url}
    />
  ));

  return (
    <>
      <div className="announcement-header">
        <h4 className="announcement-title">動画一覧</h4>

        <Link to="0" className="btn btn-primary">
          ＋ 新規作成
        </Link>
      </div>

      <div className="announcement-card">
        <div className="ann-row ann-row-header">
          <div className="ann-col ann-col-movie-cat">カテゴリ</div>
          <div className="ann-col ann-col-movie-title">タイトル</div>

          <div className="ann-col ann-col-movie-file">ファイル名</div>

          <div className="ann-col ann-col-movie-sort">表示順</div>

          <div className="ann-col ann-col-actions">操作</div>
        </div>

        {tablelist.length > 0 ? (
          <div className="ann-table-body">{tablelist}</div>
        ) : (
          <div className="ann-empty">登録されている動画はありません。</div>
        )}
      </div>
    </>
  );
};

const MoviesForm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [allSubCategoryList, setAllSubCategoryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileStatus, setFileStatus] = useState("init");
  const [fileName, setFileName] = useState("");
  const [movieUrl, setMovieUrl] = useState("");
  const [defaultCategoryId, setDefaultCategoryId] = useState(null);
  const [defaultSubCategoryId, setDefaultSubCategoryId] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFileStatus("init");
      setFile(e.target.files[0]);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "category_list",
          token: token,
        }),
      });
      if (!response.ok) {
        navigate("/");
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setAllSubCategoryList(data.subcategory_data);
        setCategoryList(data.category_data);
      }
    } catch (err) {
      console.log(err);
      setAllSubCategoryList([]);
      setCategoryList([]);
    }
  };

  const editData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "row", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setAllSubCategoryList(data.subcategory_data);
        setCategoryList(data.category_data);

        if (data.data.category_id !== "999") {
          setSubCategoryList(
            data.subcategory_data[data.data.category_id] || [],
          );
        }
        setDefaultCategoryId(String(data.data.category_id));
        setDefaultSubCategoryId(String(data.data.subcategory_id));
        setValue("title", data.data.title);

        // setValue("category_id", String(data.data.category_id));
        // setValue("subcategory_id", String(data.data.subcategory_id));
        setValue("sortno", data.data.sortno);
        setFileName(data.data.file);
        setMovieUrl(data.data.movie_url);
        console.log(data.data);
      } else {
        navigate("/movies");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (id > 0) {
        await editData(id);
      } else {
        await fetchData();
        setValue("sortno", 100);
      }
    };
    init();
  }, [id, token, setValue]);

  const onSubmit = async (data) => {
    if (file || data.id) {
      const fd = new FormData();
      if (file) {
        fd.append("upfile", file);
      }
      fd.append("id", data.id);
      fd.append("title", data.title);
      fd.append("category_id", data.category_id);
      fd.append("subcategory_id", data.subcategory_id);
      fd.append("sortno", data.sortno);
      fd.append("token", token);

      if (data.id) {
        fd.append("mode", "edit");
      } else {
        fd.append("mode", "add");
      }

      setFileStatus("uploading");
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          body: fd,
        });

        if (!response.ok) {
          throw new Error(response.status);
        }
        const resData = await response.json();
        setFileStatus("success");
        if (resData.result) {
          navigate("/movies");
        } else {
          setError(resData.error);
        }
        return true;
      } catch (err) {
        console.log(err);
        setFileStatus("failed");
        setError("通信エラーです");
      }
    } else {
      setError("ファイルを選択してください");
    }
  };

  const handleCategoyChanged = (event) => {
    const val = event.target.value;
    if (val === "" || val === "999") {
      setSubCategoryList([]);
      return;
    }
    setSubCategoryList(allSubCategoryList[val] || []);
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../movies" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>

        <h4 className="announcement-title">
          {id > 0 ? "動画の編集" : "動画の新規登録"}
        </h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <label>タイトル</label>
          <textarea
            className="frm-textarea"
            rows={3}
            {...register("title", {
              required: true,
            })}
          />
          {errors.title && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>ファイル</label>

          <input type="file" name="upfile" onChange={handleFileChange} />

          {fileStatus === "uploading" && (
            <div className="frm-info-text">アップロード中...</div>
          )}
        </div>
        {movieUrl && (
          <div className="frm-row">
            <a href={movieUrl} target="_blank">
              {fileName}
            </a>
          </div>
        )}
        <div className="frm-row">
          <label>カテゴリ</label>

          <select
            name="category_id"
            className="frm-select"
            {...register("category_id", { required: true })}
            onChange={handleCategoyChanged}
          >
            <option value="999">選択してください</option>

            {categoryList.map((item) => (
              <option key={item.id} value={item.id} selected={String(item.id) === defaultCategoryId}>
                {item.name}
              </option>
            ))}
          </select>

          {errors.category_id && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>サブカテゴリ</label>

          <select
            name="subcategory_id"
            className="frm-select"
            {...register("subcategory_id", { required: true })}
          >
            <option value="999">選択してください</option>

            {subCategoryList.map((item) => (
              <option key={item.id} value={item.id} selected={String(item.id) === defaultSubCategoryId}>
                {item.name}
              </option>
            ))}
          </select>

          {errors.subcategory_id && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>並び順</label>

          <input
            type="number"
            className="frm-input"
            {...register("sortno", {
              required: true,
            })}
          />

          {errors.sortno && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer">
          <button type="submit" className="btn btn-primary">
            更新する
          </button>
        </div>
      </form>
    </div>
  );
};

const MoviesDeleteConfirm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [viewData, setViewData] = useState([]);

  const { register, handleSubmit } = useForm();

  const fetchData = async (edit_id) => {
    if (edit_id <= 0) {
      navigate("/movies");
      return;
    }
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "detail", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setViewData(data.data);
      } else {
        navigate("/movies");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      token: token,
      mode: "delete",
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      if (!response.ok) {
        throw new Error(response.status);
      }
      const resData = await response.json();

      if (resData.result) {
        navigate("/movies");
      } else {
        setError(resData.error);
      }
      return true;
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../movies" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>

        <h4 className="announcement-title">動画の削除確認</h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <div className="delete-warning">
            このデータを削除しますか？（元に戻せません）
          </div>
        </div>

        <div className="frm-row">
          <label>タイトル</label>

          <div className="frm-static">{viewData.title}</div>
        </div>

        <div className="frm-row">
          <label>ファイル</label>

          <div className="frm-static">{viewData.file}</div>
        </div>

        <div className="frm-row">
          <label>カテゴリ</label>

          <div className="frm-static">{viewData.category_title}</div>
        </div>

        <div className="frm-row">
          <label>サブカテゴリ</label>

          <div className="frm-static">{viewData.subcategory_title}</div>
        </div>

        <div className="frm-row">
          <label>並び順</label>

          <div className="frm-static">{viewData.sortno}</div>
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer frm-footer-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => navigate("/movies")}
          >
            キャンセル
          </button>

          <button type="submit" className="btn btn-danger">
            削除する
          </button>
        </div>
      </form>
    </div>
  );
};

const Movies = () => {
  return (
    <div className="announcement-page">
      <div className="sub_title">動画</div>

      <div className="announcement-inner">
        <Routes>
          <Route path="/" element={<MoviesHome />} />

          <Route path=":id" element={<MoviesForm />} />

          <Route path="/delete/:id" element={<MoviesDeleteConfirm />} />
        </Routes>
      </div>
    </div>
  );
};

export default Movies;
